import React from 'react'
import { useHistory } from 'react-router-dom'

import { DoubleCTA } from '../../components/DoubleCTA/DoubleCTA'
import { Page } from '../../components/Page/Page'
import { useText } from '../../content'
import { useConfig } from '../../contexts/appConfig'
import { useSession } from '../../contexts/session'
import { Container, Form, Header, Paragraph } from './Auth.styles'
import { BackgroundImageSection } from './components/BackgroundImageSection'

export const MigrationInterstitialPage = () => {
  const history = useHistory()
  const { text } = useText()
  const { getAsset } = useConfig()

  const logoSrc = getAsset('RewardsProgramLogo')?.url
  const migrationMessage = text('MigrationInterstitial.Message', { brand: text('Brand.Name') })

  const handleStartMigration = () => {
    history.push('/register/migration')
  }

  const handleGoBack = () => {
    history.goBack()
  }

  return (
    <Page isScrollable>
      <BackgroundImageSection tabIndex="0" aria-label={migrationMessage}>
        <Container>
          <Form noValidate style={{ alignItems: 'center' }}>
            <img style={{ marginBottom: 30 }} width="25%" src={logoSrc} />
            <Header style={{ marginBottom: 20, backgroundColor: 'transparent' }}>
              {text('MigrationInterstitial.Heading', { brand: text('Brand.Name') })}
            </Header>
            <Paragraph style={{ marginBottom: 32, textAlign: 'center' }}>{migrationMessage}</Paragraph>

            <div style={{ width: '100%' }}>
              <DoubleCTA
                stacked
                buttons={[
                  {
                    label: 'Migrate My Rewards',
                    onClick: handleStartMigration,
                    variant: 'primary',
                  },
                  {
                    label: 'Go Back',
                    onClick: handleGoBack,
                    variant: 'secondary',
                  },
                ]}
              />
            </div>
          </Form>
        </Container>
      </BackgroundImageSection>
    </Page>
  )
}
